export const SCROLL_ID_PREFIX = 'scroll-id-'
export const CONTAINER_ID_COMPLETE_CONTENT = 'scrollable-content-complete'
export const CUSTOM_QUESTION_KEY = '-audience-question'
